import { render, staticRenderFns } from "./countryMatrix.vue?vue&type=template&id=eda8b880&scoped=true"
import script from "./countryMatrix.vue?vue&type=script&lang=js"
export * from "./countryMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda8b880",
  null
  
)

export default component.exports